/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-pascal-case */
import "./Select.css";
import React, { Fragment, useState } from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select as Select_mui,
} from "@mui/material";

const Select = ({
  label,
  list,
  errors,
  name,
  register,
  disabled = false,
  className = "",
  defaultValue = "",
  watch = (id) => id,
  onSelect = () => true,
}) => {
  const [Value, setValue] = useState("");

  watch(name) !== Value && setValue(watch(name));
  return (
    <Fragment>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label" style={{}}>
          {label}
        </InputLabel>
        <Select_mui
          native
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          label={label}
          size="small"
          className={"bg-white my-2 w-100 " + className}
          value={Value || watch(name)}
          defaultValue={defaultValue}
          error={errors && errors[name]}
          helperText={errors && errors[name]?.message}
          disabled={disabled}
          {...register}
        >
          <option
            onClick={() => {
              setValue("");
              onSelect();
            }}
            value={""}
          >
            {""}
          </option>
          {/* <MenuItem
            onClick={() => {
              setValue("");
              onSelect();
            }}
            value={""}
          >
            {""}
          </MenuItem> */}
          {list &&
            list.map((item) => (
              <option
                onClick={() => {
                  setValue(item);
                  onSelect();
                }}
                value={item}
              >
                {item}
              </option>
              // <MenuItem
              //   onClick={() => {
              //     setValue(item);
              //     onSelect();
              //   }}
              //   value={item}
              // >
              //   {item}
              // </MenuItem>
            ))}
        </Select_mui>
      </FormControl>
    </Fragment>
  );
};

export default Select;
